import Vue from "vue";
import Component from "vue-class-component";
import { TreeNode } from "element-ui/types/tree";
import TreeProps from "./treeProps";
import { Prop, Watch } from "vue-property-decorator";

/**
 * 树基本属性
 */
@Component
export default class Tree extends TreeProps {
  @Prop({ default: -1 })
  protected expandedLevel!: number;

  /**
   * 展开Keys
   */
  protected expandedKeys = new Array<any>();

  /**
   * 根据设置的层级，展开节点
   */
  @Watch("data")
  protected expandNodesByLeve() {
    if (
      this.data &&
      this.data.length > 0 &&
      this.expandedLevel > 0 &&
      this.expandedKeys.length < 1
    ) {
      let keys: string[] = [];
      for (const node of this.data) {
        this.traceNode(
          node,
          0,
          (n, l) => {
            return l < this.expandedLevel;
          },
          (n, l) => {
            keys.push(n[this.nodeKey]);
          }
        );
      }
      this.expandedKeys = keys;
    }
  }

  /**
   * node 展开
   * @param data  数据
   * @param node 节点
   */
  private nodeExpand(data, node: TreeNode<any, any>) {
    let index = this.expandedKeys.indexOf(node.key);
    if (index < 0) {
      this.expandedKeys.push(node.key);
      this.$emit("update:defaultExpandedKeys", this.expandedKeys);
    }
  }

  /**
   * 收起
   * @param data 数据
   * @param node 节点
   */
  private nodeCollapse(data, node: TreeNode<any, any>) {
    this.collapse(node);
    this.$emit("update:defaultExpandedKeys", this.expandedKeys);
  }

  /**
   * 递归收起节点及子节点
   * @param node
   */
  private collapse(node: TreeNode<any, any>) {
    let index = this.expandedKeys.indexOf(node.key);
    if (index > -1) {
      this.expandedKeys.splice(index, 1);
      if (node.childNodes) {
        for (let cNode of node.childNodes) {
          this.collapse(cNode);
        }
      }
    }
  }
  /**
   * 重新设置展开的节点
   * @param keys 展开节点的key值
   */
  public setExpandedKeys(keys: string[]) {
    this.expandedKeys = keys;
  }

  /**
   * 遍历树节点
   * @param node  节点
   * @param level 级别
   * @param condition 遍历条件
   * @param process 节点处理
   */
  protected traceNode(
    node: any,
    level = 0,
    condition: (node: any, level: number) => boolean,
    process: (node: any, level: number) => void
  ) {
    if (condition(node, level)) {
      process(node, level);
      if (node.children) {
        for (const child of node.children) {
          this.traceNode(child, level + 1, condition, process);
        }
      }
    }
  }
}
